import "./Table.scss";
import {ReactTabulator} from "react-tabulator";
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import Loader from "../Loader/Loader";
import Form from "../FormNew/Form";
import {
  useOutletContext,
  useNavigate,
  useLocation,
} from "react-router-dom";
import FormBill from "../Form/FormBill";
import {SetPrintDataContext} from "../../Pages";
import tableCalc from "../../utils/tableCalc";
import TabulatorTableOptions from "../../utils/TabulatorTableOptions";
import _axios from "../../httpService";
import TableButtons from "./TableButtons";
import useTitle from "../Hooks/useTitle";
import IsAccountingTable from "./IsAccountingTable";
import GetRemainValueInTable from "./GetRemainValueInTable";
import ModalFollowUp from "../FollowUpPage/ModalFollowUp";
import ModalDeleteRowTable from "./Modals/ModalDeleteRowTable";
import ModalConfirmOrder from "./Modals/ModalConfirmOrder";
import utilsFunction from "../../utils/utilsFunction";
import {exportXLSXFile} from "../../utils/exportCSVFile";
import {prefixUrl} from "../../utils/utilsData";
import TableModal from "./TableModal";
import ModalUploadExel from "./Modals/ModalUploadExel";

export default function Table({
                                id,
                                hideColumns,
                                height,
                                name,
                                setTitleInDashboard,
                                headerHasLogOut,
                              }) {
  let outletContext = useOutletContext();
  id = id === undefined ? outletContext : id;
  name = name === undefined ? outletContext : name;

  const location = useLocation();
  const [tableConfig, setTableConfig] = useState({title: "جدول"});
  useTitle("جدول");

  const [selectedRow, setSelectedRow] = useState();
  const [showDataKpintIsOpen, setShowDataKpintIsOpen] = useState(false);

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  // نشون دادن مودال پیگیری
  const [showModalFollowUp, setShowModalFollowUp] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalConfirmOrder, setShowModalConfirmOrder] = useState(false);
  const [showModalUploadExel, setShowModalUploadExel] = useState(false);
  const [updateTableData, setUpdateTableData] = useState(0)
  const [showArchived, setShowArchived] = useState(false)

  useEffect(() => {
    setTableConfig();

    id = id === undefined ? outletContext : id;

    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/list_json/`,
      params: {id: id, isArchived: showArchived ? '1' : '0'},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then(({data}) => {
      let columnsConfig = data.columns;

      tableCalc.addSeparator(columnsConfig, data.priceFields);
      tableCalc.addSeparator(columnsConfig, ["na_265"]); // جمع ساعت حضور در سادن

      setTitleInDashboard !== undefined && setTitleInDashboard(data.title);
      // columnsConfig = data?.columns?.unshift({
      //   formatter: "rownum",
      //   hozAlign: "center",
      //   width: 40,
      // });
      setTableConfig(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, outletContext, showArchived]);

  const [addDataModalIsOpen, setAddDataModalIsOpen] = useState(false);

  function addDataModalCallbackHandler({isOpen}) {
    setAddDataModalIsOpen(isOpen);
  }

  function submitSmsHandler() {
    let data = {
      type: "group",
      detail: {entityId: id, text: smsTextRef.current.value},
    };
    axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl")}/sendSMS/`,
      data: data,
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      setSmsModalIsOpen(false);
    });
  }

  // اینجا مدال صورتحساب رو دارم مثل بقیه آماده میکنم که کلیک کرد باز بشه
  const [invoiceModalIsOpen, setinvoiceModalIsOpen] = useState(false);

  function invoiceModalIsOpenCallbackHandler({isOpen}) {
    setinvoiceModalIsOpen(isOpen);
  }

  // آخر مودال صورت حساب
  const [editRecordrModalIsOpen, setEditRecordModalIsOpen] = useState(false);
  const [newKpintIsOpen, setNewKpintIsOpen] = useState(false);

  function newKpintIsOpenCallbackHandler({isOpen}) {
    setNewKpintIsOpen(isOpen);
  }

  function editRecordModalCallbackHandler({isOpen}) {
    setEditRecordModalIsOpen(isOpen);
  }

  function smsModalCallbackHandler({isOpen}) {
    setSmsModalIsOpen(isOpen);
  }

  const myReactTabulatorRef = useRef(null);
  const smsTextRef = useRef(null);

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if (addDataModalIsOpen === false && editRecordrModalIsOpen === false) {
        const updateTableDataRequest = axios({
          method: "GET",
          url: `${localStorage.getItem("apiUrl")}/list_json/`,
          params: {id: id, isArchived: showArchived ? '1' : '0'},
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then(({data}) => {
          // let columnsConfig = data.columns;

          // if (hideColumns) {
          //     for (const column of hideColumns) {
          //         columnsConfig.filter(
          //             ({field}) => field === column
          //         )[0].visible = false;
          //     }
          // }

          setTableConfig(data);
        });

        toast.promise(updateTableDataRequest, {
          pending: "در حال بروزرسانی جدول",
          success: "جدول با موفقیت بروزرسانی شد",
          error: "بروزرسانی جدول با مشکل مواجه شد",
        });
      }
    }
  }, [
    addDataModalIsOpen,
    editRecordrModalIsOpen,
    showDataKpintIsOpen,
    newKpintIsOpen,
    updateTableData
  ]);
  const [smsModalIsOpen, setSmsModalIsOpen] = useState(false);

  function rowClickHandler(e, row) {
    // console.log(selectedRow.getData()["primaryKey"]);
    row.getTable().getSelectedRows().length === 0
      ? setSelectedRow()
      : setSelectedRow(row);
    console.log("Row Clicked!!!");
  }

  useEffect(() => {
    const id = location?.state?.idb;

    if (id !== undefined) {
      const row = myReactTabulatorRef?.current?.table?.selectRow(id);

      row && myReactTabulatorRef?.current?.table?.setPageToRow(id);

      myReactTabulatorRef?.current?.table?.selectRow(id);
    }
    // tableConfig?.columns?.unshift({
    //   formatter: "rownum",
    //   hozAlign: "center",
    //   width: 40,
    // });
    // myReactTabulatorRef?.current?.table?.addColumn(
    //   { title: "ردیف", field: "rowNum" },
    //   true
    // );
  }, [location?.state?.id, myReactTabulatorRef?.current]);

  function removeRowHandler() {

    if (selectedRow !== undefined) {
      setShowModalDelete(true)
    } else {
      toast.error("لطفا یک سطر را انتخاب کنید")
    }
  }

  function archiveHandler() {
    if (selectedRow !== undefined) {
      const pkValue = selectedRow.getData()["primaryKey"];
      const entityName = tableConfig.entityName;
      
      const archiveRequest = _axios.post(prefixUrl() + "/customFunctions/", {
        request: "archiveRecord",
        entityName: entityName,
        pkValue: pkValue
      }).then((res) => {
        if (res.data.status) {
          setUpdateTableData(prev => prev + 1);
          setSelectedRow(undefined);
        } else {
          throw new Error(res.data.message);
        }
      });

      toast.promise(archiveRequest, {
        pending: "در حال بایگانی رکورد...",
        success: "رکورد با موفقیت بایگانی شد",
        error: {
          render({data}) {
            return data.message || "خطا در بایگانی رکورد";
          }
        }
      });
    } else {
      toast.error("لطفا یک سطر را انتخاب کنید");
    }
  }

  function unarchiveHandler() {
    if (selectedRow !== undefined) {
      const pkValue = selectedRow.getData()["primaryKey"];
      const entityName = tableConfig.entityName;

      const unarchiveRequest = _axios.post(prefixUrl() + "/customFunctions/", {
        request: "unarchiveRecord",
        entityName: entityName,
        pkValue: pkValue
      }).then((res) => {
        if (res.data.status) {
          setUpdateTableData(prev => prev + 1);
          setSelectedRow(undefined);
        } else {
          throw new Error(res.data.message);
        }
      });

      toast.promise(unarchiveRequest, {
        pending: "در حال خروج از بایگانی...",
        success: "رکورد از بایگانی خارج شد",
        error: {
          render({data}) {
            return data.message || "خطا در خروج از بایگانی";
          }
        }
      });
    } else {
      toast.error("لطفا یک سطر را انتخاب کنید");
    }
  }

  const setprint = useContext(SetPrintDataContext);

  let navigate = useNavigate();

  function exportExcelHandler() {
    if (tableConfig) {
      if (tableConfig.data.length === 0) {
        toast.error("چیزی برای اکسل وجود ندارد.");
      } else {
        const format = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        };
        const fileName = "اکسل" + new Date().toLocaleDateString("fa-ir", format);

        const filteredData = myReactTabulatorRef.current.table.getData("active")
        const normalizeData = utilsFunction.convertTabulatorDataToJson(myReactTabulatorRef?.current.props.columns, filteredData)

        exportXLSXFile(normalizeData, fileName, "")
      }
    }
  }

  function printFactorHandler() {
    let temp = {
      pkValue: selectedRow.getData()["primaryKey"],
      invoice: tableConfig.hasInvoice,
      options: JSON.stringify({0: tableConfig.options[0].value}),
      date: JSON.stringify({}),
    };
    _axios.get(`${localStorage.getItem("apiUrl")}/kprint/`, {params: temp})
      .then((response) => {
        // اینجا باید متناسب با
        // tableConfig.entityName
        // تعیین کنیم چه دیتایی برای پرینت حاضر بشه
        let sendData = {};
        if (tableConfig.entityName === "FAKKOLSELL") {
          if (response.data.sellFactorPrintSize === "8cm") {
            sendData = {
              type: "FactorPrint8cm",
              entityName: tableConfig.entityName,
              ...response.data,
            };
            setprint(sendData);
            navigate("/factorprint");
          }
        } else if (tableConfig.entityName === "TASKOL") {
          sendData = {
            type: "HAVALEANBAR",
            entityName: tableConfig.entityName,
            ...response.data,
          };
          setprint(sendData);
          navigate("/factorprint");
        } else if (tableConfig.entityName === "FAKKOLBUE") {
          sendData = {
            type: "PrintFactorBuySadan",
            data: response.data,
          }
          setprint(sendData);
          navigate("/factorprint");
        } else {
          toast.error("موجدیت مورد نظر دارای پرینت نمی باشد")
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const printDocumentList = async () => {
    const pkValue = selectedRow.getData()["CODE_SAN"]
    try {
      const result = await _axios
        .get(prefixUrl() + '/accountingDocument/?request=documentData&documentCode=' + pkValue)
      if (result.data.status) {
        result.data.documentData.tableData = result.data.documentData.documentDetails
        const sendPrintData = {
          type: "ControlUnderTablePrint",
          data: result.data.documentData,
          title: "سند حسابداری"
        };
        setprint(sendPrintData);
        navigate("/factorprint");
      } else {
        toast.error(result.message)
      }
      return undefined
    } catch (error) {
      console.log(error)
    }
  }

  function handleOrderDetails() {
    const customId = selectedRow.getData()[tableConfig.isException.edit.id];
    const destinationAddress = tableConfig.isException.edit.destination;
    navigate(destinationAddress, {
      state: {mode: "view", id: customId, title: tableConfig?.formHeaderTitle}
    });
  }

  function addNewHandler() {
    if (
      tableConfig.isException !== undefined &&
      tableConfig.isException.add.status === true
    ) {
      const destinationAddress = tableConfig.isException.add.destination; // /sellFactor || /storeRemittance || /opration/1-m
      navigate(destinationAddress, {state: {title: tableConfig?.formHeaderTitle}});
    } else {
      setAddDataModalIsOpen(true);
    }
  }

  function editHandler() {
    //  there are two  modes Here
    //if there is exception and I want To Send User TO another Component
    // Or
    // There is  no exception an I want To show Modal TO user
    // So at First I want to check If there is any  exception


    if (
      tableConfig.isException !== undefined &&
      tableConfig.isException.edit.status === true
    ) {

      // axios({
      //   method: "GET",
      //   url: `${localStorage.getItem("apiUrl")}/get-form/`,
      //   params: {
      //     pkValue: selectedRow.getData()["primaryKey"],
      //     id: id,
      //     state: "edit",
      //   },
      //
      //   headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
      // }).then((response) => {
      const customId = selectedRow.getData()[tableConfig.isException.edit.id];
      const destinationAddress = tableConfig.isException.edit.destination; // /sellFactor || /storeRemittance || /opration/1-m
      // اینجا یه استثنا داریم و اون اینه که  اگه قرار بود فاکتور خرید سابق بره باید با کانتکس دیتا رو پاس بدم بهش
      if (destinationAddress === "/Operation/1-m" || destinationAddress === "/buyFactorSadan") {
        axios({
          method: "GET",
          url: `${localStorage.getItem("apiUrl")}/get-form/`,
          params: {
            pkValue: selectedRow.getData()["primaryKey"],
            id: id,
            state: "edit",
          },
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then((response) => {
          setprint(response.data);
          const pageNum = myReactTabulatorRef?.current?.table?.getPage();
          navigate(destinationAddress, {state: {page: pageNum}});
        });
      } else {
        navigate(destinationAddress, {
          state: {mode: "edit", id: customId, manualDocumentId: customId, title: tableConfig?.formHeaderTitle}
        });
      }

      //         اتمام این استثنا مسخره
      //

      // حالا
      // برو
      // توی
      // همون
      // صفحه
      // });
    } else {
      setEditRecordModalIsOpen(true);
      // and Then USeEffect Will Fire Ti do What Ever They Wrote...
    }
  }

  function editHandler2() {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/get-form/`,
      params: {
        pkValue: selectedRow.getData()["primaryKey"],
        id: id,
        state: "edit",
      },

      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      setprint(response.data);

      // here is An Exception in cameron

      if (tableConfig.isException !== undefined) {
        const customId = selectedRow.getData()[tableConfig.isException.id];
        const destinationAddress = tableConfig.isException.destination; // => // /sellFactor || /storeRemittance
        navigate(destinationAddress, {state: {mode: "edit", id: customId}});
      } else {
        navigate("/Operation/2-m");
      }
    });
  }

  const postPrintHandler = () => {
    _axios.get(`${localStorage.getItem("apiUrl")}/print/?request=customerClubSellFactor&factorId=` + selectedRow.getData()["primaryKey"])
      .then((response) => {
        if (response.data.status) {
          const sendData = {
            type: "SellFactorPostPrint",
            ...response.data.data,
          };
          setprint(sendData);
          navigate("/factorprint");
        } else {
          toast.error(response.data.message)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    setTimeout(() => {
      if (myReactTabulatorRef?.current?.table && location?.state?.primaryKeyFilter) {
        myReactTabulatorRef.current.table.setFilter('primaryKey', '=', parseInt(location.state.primaryKeyFilter))
      }
    }, 100)
  }, [tableConfig])
  const SendTabulatorFilteredData = () => {
    const tbData = myReactTabulatorRef.current.table;

    tbData.deselectRow();
    tbData.selectRow("visible");
    const tbSelected = tbData.getSelectedData();
    const requestArray = [];
    const countArray = [];

    for (let v in countArray) {
    }
    tbSelected.map((v) => {
      requestArray.push(v.primaryKey);
    });
    tbSelected.map((v) => countArray.push(parseInt(v.na_326)));
    requestArray.shift();
    countArray.shift();

    const array_to_send = [];

    // requestArray.map(v => countArray.push(parseInt(v.na_326)))

    requestArray.map((v, index) => {
      [...Array(countArray[index])].map((v2, index2) => {
        array_to_send.push(v);
      });
    });

    //    بریم که درخواست بزنیم بک
    const CodesArrayFormData = new FormData();
    CodesArrayFormData.append("id", `[${array_to_send}]`);
    CodesArrayFormData.append("type", "id");
    let sendData = axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl")}/barcode/`,
      // params: {id: temp, type: typeToSendBack},
      data: CodesArrayFormData,
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => {
        if (response.data.length > 0) {
          response.data.type = "barcodePrintFromBuyBill";
          const sendData = {type: response.data.type, data: response.data};
          setprint(sendData);

          navigate("/factorprint");
        }
      })
      .catch((error) => {
        console.log(error)
      });

    toast.promise(sendData, {
      pending: "در حال دریافت بارکد... لطفا صبر کنید. ",
      success: "بارکد با موفقیت دریافت شد.",
      error: "دریافت بارکد  با مشکل مواجه شد",
    });
  };

  if (tableConfig !== undefined) {
    return (
      <div className="table-component">

        <div>
          {(tableConfig.canInsert ||
            tableConfig.canDelete ||
            tableConfig.hasKpi ||
            tableConfig.hasInvoice ||
            tableConfig.hasMobile ||
            tableConfig.canEdit) && (
            <div className="btn-container d-flex flex-stat mx-1">
              {tableConfig.canInsert && (
                <>
                  <TableButtons.AddNew onClick={addNewHandler}/>
                </>
              )}
              {tableConfig.canDelete && (
                <TableButtons.DeleteButton
                  removeRowHandler={removeRowHandler}
                />
              )}
              <>
                <TableButtons.ExcelExport
                  exportExcelHandler={exportExcelHandler}
                />
              </>

              {id === "395-s" && (
                <TableButtons.OrderDetails
                  onClick={handleOrderDetails}
                  selectedRow={selectedRow}
                />
              )}
              {id === "395-s" && selectedRow?.getData()?.na_148 === "ثبت" && (
                <TableButtons.ConfirmOrder
                  onClick={() => setShowModalConfirmOrder(true)}
                  selectedRow={selectedRow}
                />
              )}
              {tableConfig.canEdit && (
                <TableButtons.EditRowInTable2
                  editHandler2={editHandler}
                  selectedRow={selectedRow}
                />
              )}
              {tableConfig.hasMobile && (
                <>
                  {
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => setSmsModalIsOpen(true)}
                    >
                      <i className="fa fa-edit"></i> پیامک
                    </button>
                  }


                  {smsModalCallbackHandler &&
                    <><TableModal
                      title={"متن پیامک"}
                      isOpen={smsModalIsOpen}
                      modalCallback={smsModalCallbackHandler}
                    >
                      <>
                        <p>لطفا متن پیامک را وارد کنید</p>
                        <textarea
                          className="sms-textarea  my-3"
                          ref={smsTextRef}
                        ></textarea>
                        <div className={'w-100 text-center'}>
                          <button
                            className="btn btnFixedOverWrite"
                            onClick={submitSmsHandler}
                          >
                            ارسال
                          </button>
                        </div>
                      </>
                    </TableModal></>

                  }
                </>
              )}
              {/* در هر صورت این نمایش داده میشه. دکمه پرینت بارکد_ بعد از  گزینه های افزودن ویرایش و حذف میاد*/}
              {id === "1-s" && (
                <>
                  <TableButtons.BarcodePrintInTable
                    SendTabulatorFilteredData={SendTabulatorFilteredData}
                  />
                </>
              )}
              {tableConfig.hasKpi && (
                <>
                  {tableConfig.entityName === "FAKLOZBUE" ||
                  tableConfig.entityName === "FAKKOLBUE" ? (
                    <TableButtons.AddKpiButton
                      id={id}
                      tableConfig={tableConfig}
                    />
                  ) : tableConfig.entityName === "FAKJOZSELL" ||
                  tableConfig.entityName === "FAKKOLSELL" ? (
                    <TableButtons.AddKpiButton
                      id={id}
                      tableConfig={tableConfig}
                    />
                  ) : (
                    <TableButtons.AddKpiButton
                      id={id}
                      tableConfig={tableConfig}
                    />
                  )}
                  {(id === "905-s" || id === "473-s") && (
                    <>
                      <TableButtons.ShowArchivedToggle
                        showArchived={showArchived}
                        onClick={() => {
                          setShowArchived(prev => !prev);
                          setSelectedRow(undefined);
                        }}
                      />
                      {showArchived ? (
                        <TableButtons.UnarchiveButton
                          onClick={unarchiveHandler}
                          selectedRow={selectedRow}
                        />
                      ) : (
                        <TableButtons.ArchiveButton
                          onClick={archiveHandler}
                          selectedRow={selectedRow}
                        />
                      )}
                    </>
                  )}
                </>
              )}

              {tableConfig.hasInvoice && (
                <>
                  {tableConfig.options.length === 1 &&
                  tableConfig.hasDate === false ? (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={printFactorHandler}
                      disabled={selectedRow === undefined}
                    >
                      <i className="far fa-file-alt"></i>
                      {tableConfig.title2}
                    </button>
                  ) : (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => setinvoiceModalIsOpen(true)}
                      // onClick={printFactorHandler}
                      disabled={selectedRow === undefined}
                    >
                      <i className="far fa-file-alt"></i>
                      {tableConfig.title2}
                    </button>
                  )}

                  {invoiceModalIsOpen &&
                    <>
                      <><TableModal
                        title={tableConfig.title2}
                        isOpen={invoiceModalIsOpen}
                        modalCallback={invoiceModalIsOpenCallbackHandler}
                      >
                        <FormBill
                          id={id}
                          invoiceId={tableConfig.hasInvoice}
                          primaryKey={
                            selectedRow === undefined
                              ? undefined
                              : selectedRow.getData()["primaryKey"]
                          }
                          data={tableConfig.options}
                          hasDate={tableConfig.hasDate}
                        />
                      </TableModal></>
                    </>}
                </>
              )}

              {tableConfig?.hasEditor && (
                <>
                  {tableConfig.hasDate === false ? (
                    <button
                      className="btn btnFixedOverWrite"
                      disabled={selectedRow === undefined}>
                      ویرایشگر متن
                    </button>
                  ) : (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => navigate("/text-editor", {
                        state: {
                          entity: tableConfig?.entityName,
                          pkValue: selectedRow._row.data.primaryKey
                        }
                      })}
                      disabled={selectedRow === undefined}>
                      ویرایشگر متن
                    </button>
                  )}
                </>
              )}

              {tableConfig?.canCopyDocuments && (
                <>
                  <button
                    className="btn btnFixedOverWrite"
                    onClick={() => navigate("/coding/DocumentIssuance", {
                      state: {
                        copyPkValue: selectedRow._row.data.CODE_SAN
                      }
                    })}
                    disabled={selectedRow === undefined}>
                    کپی سند
                  </button>

                </>
              )}
              {tableConfig?.documentExcelUpload && (
                <>
                  <button
                    className="btn btnFixedOverWrite"
                    onClick={() => navigate("/coding/ImportDocumentIssuance")}>
                    بارگذاری فایل اکسل
                  </button>

                </>
              )}

              {tableConfig.postPrint && (
                <>
                  {tableConfig.options.length === 1 &&
                  tableConfig.hasDate === false ? (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={postPrintHandler}
                      disabled={selectedRow === undefined}>
                      پرینت پستی
                    </button>
                  ) : (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => setinvoiceModalIsOpen(true)}
                      disabled={selectedRow === undefined}
                    >
                      <i className="far fa-file-alt"></i>
                      پرینت پستی
                    </button>
                  )}
                </>
              )}

              {tableConfig.hasDocumentPrint && (
                <>
                  <button
                    className="btn btnFixedOverWrite"
                    onClick={printDocumentList}
                    disabled={selectedRow === undefined}
                  >
                    <i className="far fa-file-alt"></i>
                    {tableConfig.title2}
                  </button>
                </>
              )}

              {tableConfig.isAccounting && (
                <IsAccountingTable selectType={"2"} selectedRow={selectedRow} entityName={tableConfig.entityName}/>
              )}
              {tableConfig.isAccounting && (
                <GetRemainValueInTable
                  entityName={tableConfig.entityName}
                  selectedRow={selectedRow}/>
              )}
              {/* Front End Must Show All KPIs  even if  hasKpi is False */}
              {tableConfig.allKpi && tableConfig.allKpi.kpi && (
                <TableButtons.KpiButtons data={tableConfig}/>
              )}
              {tableConfig.followUpSystem &&
                <>
                  <TableButtons.FollowUpSystem selectedRow={selectedRow}
                                               onClickFollowUpSystem={() => setShowModalFollowUp(true)}/>
                  {showModalFollowUp && <ModalFollowUp listName={tableConfig.entityName}
                                                       pkValue={selectedRow.getData()['primaryKey']}
                                                       setShowModal={setShowModalFollowUp}
                                                       onClose={() => setShowModalFollowUp(false)}/>}
                </>

              }
              {tableConfig.followUpSystem &&
                <>
                  <TableButtons.FollowUpList selectedRow={selectedRow}
                                             listName={tableConfig.entityName}/>
                </>

              }
              {tableConfig.accountingDocument &&
                <>
                  <TableButtons.GoToDocumentForm
                    selectedRow={selectedRow}
                    listName={tableConfig.entityName}
                  />
                </>}

              {tableConfig?.hiSiteRequest && (
                <>
                  {tableConfig.hasDate === false ? (
                    <button
                      className="btn btnFixedOverWrite"
                      disabled={selectedRow === undefined}>
                      ثبت درخواست
                    </button>
                  ) : (
                    <button
                      className="btn btnFixedOverWrite"
                      onClick={() => navigate("/new-order-form", {
                        state: {
                          entity: tableConfig?.entityName,
                          pkValue: selectedRow._row.data.primaryKey
                        }
                      })}
                      disabled={selectedRow === undefined}>
                      ثبت درخواست
                    </button>
                  )}
                </>
              )}
              {tableConfig?.leadExcel && (
                <button
                  className="btn btnFixedOverWrite"
                  onClick={() => setShowModalUploadExel(true)}>
                  بارگذاری فایل اکسل
                </button>
              )}
              {tableConfig?.leadAllocation && (
                <button
                  className="btn btnFixedOverWrite"
                  onClick={() => navigate("/lead-allocation")}>
                  تخصیص لید
                </button>
              )}
            </div>
          )}
          <ReactTabulator
            // NOTE: Don't add bootstrap "table" class
            // className="table"
            ref={myReactTabulatorRef}
            data={tableConfig.data}
            columns={tableConfig.columns}
            options={TabulatorTableOptions.style1}
            index={"primaryKey"}
            events={{rowClick: rowClickHandler}}
            // printRowRange={"active"}
          />
        </div>

        {editRecordrModalIsOpen &&
          <><TableModal
            title={"ویرایش"}
            isOpen={editRecordrModalIsOpen}
            modalCallback={editRecordModalCallbackHandler}
          >
            <Form
              id={id}
              primaryKey={
                selectedRow === undefined
                  ? undefined
                  : selectedRow.getData()["primaryKey"]
              }
            />
          </TableModal></>
        }

        {addDataModalIsOpen && <><TableModal
          title={"افزودن"}
          isOpen={addDataModalIsOpen}
          modalCallback={addDataModalCallbackHandler}
        ><Form id={id}/></TableModal></>}

        {showModalDelete && <ModalDeleteRowTable tableConfig={tableConfig}
                                                 setSelectedRow={setSelectedRow}
                                                 selectedRow={selectedRow}
                                                 onClose={() => setShowModalDelete(false)}/>}

        {showModalConfirmOrder && selectedRow && (
          <ModalConfirmOrder
            selectedRow={selectedRow}
            setUpdateTableData={setUpdateTableData}
            onClose={() => setShowModalConfirmOrder(false)}
          />
        )}

        {showModalUploadExel &&
          <ModalUploadExel onClose={() => setShowModalUploadExel(false)} setUpdateTableData={setUpdateTableData}/>}
      </div>
    );
  } else {
    return (
      <>
        <div></div>
        <Loader/>
      </>
    );
  }
}
